import * as push from "./push.json";
import * as ringRotate from "./ring-rotate.json";

export const Animations = {
  ringRotate: ringRotate,
  push: push,
};

export type AnimationsType = keyof typeof Animations;

export const getAnimationByType = (type: AnimationsType) => JSON.parse(JSON.stringify(Animations[type]));
